<dx-drop-down-box #editTemplateDropDown
  class="edit-template-drop-down"
  [dropDownOptions]="{
    width: dropDownWidth,
    height: dropDownHeight,
    resizeEnabled: true,
  }"
>
  <div *dxTemplate="let data of 'content'" class="ctl-search-area">
    <div class="content">
      <div class="first-table-container">
        <dk-dx-data-table2
          *ngIf="gridCtlList"
          [dataSource]="dataSource"
          [columnList]="columns"
          height="100%"
          [columnTransactions]="false"
          [filterValue]="filterValue ? filterValue : null"
          [gridCtlList]="gridCtlList"
          (focusedRowChanged)="focusChanged($event, false)"
          [dontSelectDataSource]="true"
          [isGroupingYn]="false"
          (rowDblClick)="focusChanged($event, true)"
          [keyExpr]="key"
          (focusedCellChanging)="focusedCellChanging($event)"
        >
        </dk-dx-data-table2>
      </div>
    </div>

    <div class="search-btn-area">
      <div>
        <dx-button
          icon="check"
          stylingMode="contained"
          text="Seç"
          type="success"
          [width]="150"
          (onClick)="chooseBtnClick()"
        >
        </dx-button>
      </div>
      <div class="search-right-btn">
        <dx-button
          icon="close"
          stylingMode="contained"
          text="İptal"
          type="danger"
          [width]="150"
          (onClick)="cancelBtnClick()"
        >
        </dx-button>
      </div>
    </div>
  </div>

  <div *dxTemplate="let data of 'dropDownButton'">
    <i class="dx-icon dx-icon-search"></i>
  </div>
</dx-drop-down-box>
